import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

/**
 * An event that is fired when a relation object is edited through another content object form.
 * No result is expected
 *
 * @memberof FlotiqPlugins.Events
 * @event "flotiq.form.relation::after-submit"
 * @type {FormRelationAfterSubmitEvent}
 */

/**
 * @class
 * @extends FormRenderFieldEvent
 * @memberof FlotiqPlugins.Events
 * @name FormRelationAfterSubmitEvent
 * @property {object} contentType Content type for the main object form
 * @property {object} contentObject Main content object currently editing
 * @property {string} fieldName Name of the relation field
 * @property {{dataUrl: string, type: string}} relation Relation field value
 * @property {object} relationContentObject Relation content object wihtout hydration
 * @property {object} relationContentType Relation content type
 * @property {boolean} isSuccess If editing relation object was successful
 * @property {object} errors Errors of editing relation object
 * @property {object} values Form values
 */
export class FormRelationAfterSubmitEvent extends IFlotiqPluginEvent {
  contentType;
  contentObject;
  fieldName;
  relation;
  relationContentObject;
  relationContentType;
  isSuccess;
  errors;
  values;
}
